export default __webpack_public_path__ + "static/media/line-bg1.75cbd5cc.png";